import * as React from 'react'
import { ColumnHeadline } from './Shared'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'
import { OfferInstance } from '../../../../models/Offer'

export const Treatment = ({ offer }: { offer: OfferInstance }) => {
  const renderItems = () => {
    const translations = {
      crown: ['Implantat', 'Implantate'],
      bridge: ['Brückenglied', 'Brückenglieder'],
      locator: ['Locator', 'Locatoren'],
      telescope: ['Teleskop', 'Teleskope'],
    }

    const items = []
    const recommendations = offer.recommendationSums
    for (let key in recommendations) {
      const [singular, plural] = translations[key]
      const count = recommendations[key]
      items.push(
        <Item key={key}>
          <Icon src={Utils.getAssetPath('/assets/calculator/result/' + key + '.svg')} />
          <div>
            <Count>{count}</Count> {count === 1 ? singular : plural}
          </div>
        </Item>
      )
    }
    return items
  }

  return (
    <Container>
      <ColumnHeadline>Ihre Behandlung</ColumnHeadline>
      <List>{renderItems()}</List>

      <Notice>Der berechnete Preis beinhaltet die Implantation und prothetische Versorgung (Zahnersatz).</Notice>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 5rem;
  padding-top: 2rem;
  padding-left: 2rem;
  @media (max-width: 950px) {
    margin-right: 20px;
    margin-left: 0;
    padding-left: 20px;
    padding-top: 0;
    padding-bottom: 30px;
  }
`

const List = styled.ul`
  list-style: none;
  padding-top: 5px;
`

const Item = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0;
`

const Count = styled.span`
  color: ${(props) => props.theme.greenColor};
  font-size: 22px;
`

const Notice = styled.div`
  font-size: 11px;
  margin-top: 1rem;
  @media (max-width: 600px) {
    margin-top: 0;
  }
`

const Icon = styled.img`
  margin-right: 0.5rem;
  width: 1.5rem;
  object-fit: contain;
  height: 1.5rem;
`

